import { createAction } from "redux-actions";
import { GET_TRANVIA_PARAMETERS } from "../constants";
import { feathersCreateData } from "../services";
//import { isMobile } from 'react-device-detect';
export const getParametersTranviaServices = createAction(GET_TRANVIA_PARAMETERS, () => feathersCreateData('tranvia-services',{
    access : "GET_TRANVIA_PARAMETERS",
})())